import type { TimeEntryLike } from '../types'

// The API returns seconds. Round down to the precision accepted by the editor
// so rounding a remaining allowance up cannot push the total past 24 hours.
export const getCloneDailyDurationBudget = (
  entries: TimeEntryLike[],
  minMinutes: number | boolean
) => {
  const totalSeconds = entries.reduce((total, entry) => {
    const seconds = Number(entry.duration)
    if (['deleted', 'discarded'].includes(entry.status ?? '')) return total
    return total + (Number.isFinite(seconds) && seconds > 0 ? seconds : 0)
  }, 0)
  const factor = minMinutes ? 10 : 100
  const remainingHours =
    Math.floor((Math.max(0, 86400 - totalSeconds) * factor) / 3600) / factor
  return { totalHours: totalSeconds / 3600, remainingHours }
}
